/**
 * Created by neo on 30.11.16.
 */
import { makeAutoObservable } from 'mobx';
import { Athlete, AthleteApi } from '../Model/Athlete/Athlete';
import { User } from '../Model/User';
import SentryService from '../Services/SentryService';
import AppAuthToken from '../Services/Security/AppAuthToken';
import { Token } from '../Services/Security/Token';

function createAuthenticationStore() {
  return makeAutoObservable({
    isAuthenticating: false,
    athlete: undefined as Athlete | undefined,
    authTokenCheckInProgress: true,
    authenticated: false,

    storeAccessToken(accessToken: string): Promise<Athlete> {
      AppAuthToken.authData = new Token({ access_token: accessToken });
      return this.checkAuthData();
    },

    async checkAuthData() {
      this.authTokenCheckInProgress = true;
      if (!this.athlete) {
        try {
          const athlete = await AthleteApi.me();
          return this.setUserData(athlete);
        } catch (err) {
          this.authTokenCheckInProgress = false;
          throw err;
        }
      }
      this.authTokenCheckInProgress = false;
      return this.athlete;
    },

    setAthleteData(athlete: Athlete): Athlete {
      this.athlete = athlete;
      SentryService.setUser(athlete);
      return athlete;
    },

    setUserData(athlete: Athlete): Athlete {
      this.athlete = athlete;
      this.authenticated = true;
      this.isAuthenticating = false;
      this.authTokenCheckInProgress = false;
      return this.athlete;
    },

    get athleteId(): string | undefined {
      return this.athlete?.id;
    },

    get user(): User | undefined {
      return this.athlete?.user;
    },

    get userId(): string | undefined {
      return this.user?.id;
    },
  });
}

export const authenticationStore = createAuthenticationStore();

export type AuthenticationStore = ReturnType<typeof createAuthenticationStore>;
